import React from 'react';
import Tilt from './Fx/Tilt';

const truncate = (text = '', n: number) => (text.length > n ? `${text.substring(0, n).trimEnd()}…` : text);

const EventCard = ({ event, index = 0, featured = false }: { event: any; index?: number; featured?: boolean }) => {
   const number = String(index + 1).padStart(3, '0');

   return (
      <Tilt className="group h-full rounded-sm">
         <article
            className={`relative flex h-full overflow-hidden rounded-sm border border-white/[0.07] bg-ink-900/60 backdrop-blur-md transition-colors duration-500 group-hover:border-signal/40 ${
               featured ? 'flex-col lg:flex-row' : 'flex-col'
            }`}
         >
            {event.cover && (
               <div
                  className={`relative overflow-hidden ${
                     featured ? 'aspect-[16/10] lg:aspect-auto lg:w-3/5' : 'aspect-[4/3]'
                  }`}
               >
                  <img
                     src={event.cover}
                     alt=""
                     loading="lazy"
                     className="absolute inset-0 h-full w-full object-cover grayscale contrast-125 brightness-[0.7] transition-[transform,filter] duration-[1.2s] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-105 group-hover:grayscale-0 group-hover:brightness-90"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/20 to-transparent" />
                  <div className="absolute inset-0 bg-signal mix-blend-multiply opacity-30 transition-opacity duration-700 group-hover:opacity-0" />
               </div>
            )}

            <div className={`relative flex flex-1 flex-col p-5 ${featured ? 'lg:p-10 lg:justify-end' : ''}`}>
               <div className="mb-4 flex items-center justify-between">
                  <span className="font-mono text-[11px] tracking-[0.2em] text-signal">CASE/{number}</span>
                  {event.tags?.[0]?.label && <span className="chip">{event.tags[0].label}</span>}
               </div>
               <h2
                  className={`font-display leading-[1.02] text-bone ${
                     featured ? 'text-4xl md:text-5xl lg:text-6xl' : 'text-[1.9rem]'
                  }`}
               >
                  {event.title}
               </h2>
               {event.summary && (
                  <p className={`mt-4 text-sm leading-relaxed text-bone-muted ${featured ? 'md:text-base max-w-xl' : ''}`}>
                     {truncate(event.summary, featured ? 320 : 150)}
                  </p>
               )}
               <div className="mt-auto flex items-center gap-3 pt-6">
                  <span className="h-px flex-1 origin-left scale-x-[0.15] bg-signal transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-x-100" />
                  <span className="eyebrow text-bone transition-colors group-hover:text-signal">Open file</span>
               </div>
            </div>
         </article>
      </Tilt>
   );
};

export default EventCard;
